module.exports = __webpack_public_path__ + "img/usa-genitourinary-diseases-male.75593471.png";